export default Backbone.Router.extend({
  routes: {
    'quickView/:id/': 'quickView',
  },

  getRoot() {
    const path = window.location.pathname;
    return path.slice(0, path.indexOf('/', 1) + 1);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/routers/search_router.js